import { render, staticRenderFns } from "./PaymentVouchers.vue?vue&type=template&id=54428b3a"
import script from "./PaymentVouchers.vue?vue&type=script&lang=js"
export * from "./PaymentVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports